export default "https://npm-assets.fiverrcdn.com/assets/@fiverr/search_perseus/apps/Animated_Gifs_de-DE.5716ef1.vtt";